import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation, useQuery } from "react-query";
import { QueryKeys } from "../queryKeys";
import { BasePagingResponse, BaseResponse } from "../_types";

export interface IProduct {
  id: number;
  productCode: string;
  productName: string;
  productGroupId: number;
  salePrice: number;
  buyingPrice: number;
  taxRateId: number;
  unit: number;
  isOpenPrice: boolean;
  barcode: string;
  status: "BLOCKED" | "ACTIVE" | "PASSIVE" | null;
  createDate: string;
  updateDate: string;
  createUserId: number;
  updateUserId: number;
  deleteDate: string | null;
  deleteUserId: number;
}

export type GetProductsResponse = BasePagingResponse<Array<IProduct>>;

export type GetProductsRequest = {
  page: number;
  size: number;
  orderByDesc: boolean;
  orderBy: string;
  status?: "BLOCKED" | "ACTIVE" | "PASSIVE" | string;
  groupId?: number;
  currencyCode?: string;
  [key: string]: string | number | boolean | undefined;
};

async function getProducts(
  data: GetProductsRequest
): Promise<GetProductsResponse> {
  try {
    return (await axiosInstance.post("/Product/GetProducts", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetProducts() {
  return useMutation<GetProductsResponse, Error, GetProductsRequest>(
    (variables) => getProducts(variables)
  );
}